import { $t } from "./services/i18n";

// Definir los módulos según las variables de entorno
const modules = {
  guard: process.env.VUE_APP_GUARD === "true",
  carrier: process.env.VUE_APP_CARRIER === "true",
  patrol: process.env.VUE_APP_PATROL === "true",
};


export const AppMenus = {
  navbarTopRight: [],
  navbarTopLeft: [],
  navbarSideLeft: [
    {
      to: '/home',
      label: $t('home'),
      icon: 'pi pi-home text-primary',
      iconcolor: '',
      target: '',
    }, // Sección Accesses (solo si guard está activo)
    ...(modules.guard
      ? [{
        label: $t('Accesses'),
        icon: 'pi pi-sign-in text-primary',
        items: [
          {
            to: '/home/guard',
            label: $t('moduleGuard'),
            icon: 'pi pi-chart-pie text-primary',
          },
          {
            to: '/accessrequests',
            label: $t('accessrequests'),
            icon: 'pi pi-id-card text-primary',
          },
          {
            to: '/accesslog',
            label: $t('accessLog'),
            icon: 'pi pi-book text-primary',
          },
          {
            to: '/accessvip',
            label: $t('accessvip'),
            icon: 'pi pi-star text-primary',
          },
          {
            to: '/accesslogvip',
            label: $t('accesslogvip'),
            icon: 'pi pi-book text-primary',
          },
        ],
      }]
      : []),
    // Sección Vendors (si guard o carrier están activos)
    ...(modules.guard || modules.carrier
      ? [{
        label: $t('vendors'),
        icon: 'pi pi-building text-primary',
        items: [
          {
            to: '/vendors',
            label: $t('vendors'),
            icon: 'pi pi-building text-primary',
          },
          {
            to: '/bitacora',
            label: $t('bitacora'),
            icon: 'pi pi-book text-primary',
          },
          {
            to: '/employees',
            label: $t('employees'),
            icon: 'pi pi-users text-primary',
          },
          {
            to: '/vehicles',
            label: $t('vehicles'),
            icon: 'pi pi-car text-primary',
          },
          {
            to: '/tools',
            label: $t('tools'),
            icon: 'pi pi-wrench text-primary',
          },
          {
            to: '/computers',
            label: $t('computers'),
            icon: 'pi pi-desktop text-primary',
          },
          {
            to: '/sua',
            label: $t('suaMenu'),
            icon: 'pi pi-verified text-primary',
          },
        ],
      }]
      : []),
    ...(modules.carrier
      ? [{
        label: $t('carrier'),
        icon: 'pi pi-truck text-primary',
        items: [
          {
            to: '/carrierrequests',
            label: $t('carrierrequests'),
            icon: 'pi pi-id-card text-primary',
          },
          {
            to: '/ramps-dashboards',
            label: $t('rampsDashboards'),
            icon: 'pi pi-chart-pie text-primary',
          },
          {
            to: '/carrier_accesslog',
            label: $t('carrier_accesslog'),
            icon: 'pi pi-book text-primary',
          },
          {
            to: '/ramps-screen',
            label: $t('rampsScreen'),
            icon: 'pi pi-desktop text-primary',
          },
        ],
      }]
      : []),
    // Sección Patrols (solo si patrol está activo)
    ...(modules.patrol
      ? [{
        label: $t('patrol'),
        icon: 'pi pi-map-marker text-primary',
        items: [
          {
            to: '/home/patrol',
            label: $t('modulePatrol'),
            icon: 'pi pi-chart-line text-primary',
          },
          {
            to: '/round',
            label: $t('rounds'),
            icon: 'pi pi-compass text-primary',
          },
          {
            to: '/reports',
            label: $t('reports'),
            icon: 'pi pi-file-pdf text-primary',
          },
          {
            to: '/finding',
            label: $t('findings'),
            icon: 'pi pi-exclamation-circle text-primary',
          },
          {
            to: '/incidents',
            label: $t('incidents'),
            icon: 'pi pi-exclamation-triangle text-primary',
          },
          {
            to: '/patrols',
            label: $t('roundRoute'),
            icon: 'pi pi-directions text-primary',
          },
          {
            to: '/tags',
            label: $t('tags'),
            icon: 'pi pi-tag text-primary',
          },
          {
            to: '/tasks',
            label: $t('tasks'),
            icon: 'pi pi-list text-primary',
          },
        ],
      }]
      : []),
    {
      label: $t('settings'),
      icon: 'pi pi-cog text-primary',
      items: [
        {
          to: '/users',
          label: $t('users'),
          icon: 'pi pi-users',
        },
        {
          to: '/userdepts',
          label: $t('departments'),
          icon: 'pi pi-sitemap',
        },
        {
          to: '/vendorslevels',
          label: $t('vendorsCategories'),
          icon: 'pi pi-bookmark',
        },
        {
          to: '/accessrequestpriorities',
          label: $t('priorities'),
          icon: 'pi pi-sort-alt',
        },
        {
          to: '/accessrequeststatus',
          label: $t('statusRequests'),
          icon: 'pi pi-check-circle',
        },
        {
          to: '/userstatus',
          label: $t('statusUsers'),
          icon: 'pi pi-check-circle',
        },
        {
          to: '/vendorsstatus',
          label: $t('statusVendors'),
          icon: 'pi pi-check-circle',
        },
        {
          to: '/repsestatus',
          label: $t('statusRepse'),
          icon: 'pi pi-check-circle',
        },
        {
          to: '/permissions',
          label: $t('permissions'),
          icon: 'pi pi-th-large text-primary',
        },
        {
          to: '/roles',
          label: $t('roles'),
          icon: 'pi pi-th-large text-primary',
        },
      ],
    },
  ],
  exportFormats: {
    print: {
      label: $t('print'),
      icon: 'pi pi-print',
      type: 'print',
      ext: 'print',
    },
    pdf: {
      label: $t('pdf'),
      icon: 'pi pi-file-pdf',
      type: 'pdf',
      ext: 'pdf',
    },
    excel: {
      label: $t('excel'),
      icon: 'pi pi-file-excel',
      type: 'excel',
      ext: 'xlsx',
    },
    csv: {
      label: $t('csv'),
      icon: 'pi pi-table',
      type: 'csv',
      ext: 'csv',
    },
  },
};
